var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-main" }, [
    _c("div", { staticClass: "container-app" }, [
      _c(
        "div",
        { staticClass: "icon", style: { background: "" + this.appBgColor } },
        [_c("i", { class: _vm.appIcon })]
      ),
      _c("data", { attrs: { value: "" } }),
      _vm._v(" "),
      _c("div", { staticClass: "name" }, [
        _c("strong", [_vm._v("\n        " + _vm._s(_vm.appTitle) + "\n      ")])
      ])
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "container-list" },
      _vm._l(_vm.list, function(value, index) {
        return _c("li", { key: index, class: ["item", _vm.color] }, [
          _vm._v("\n      - " + _vm._s(value) + "\n    ")
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d517e7b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d517e7b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/ModuleTransactionCount.vue
// module id = null
// module chunks = 